export default "__VITE_ASSET__0abd16c8__"